import React from 'react';
import { func, shape, string } from 'prop-types';
import { components } from 'react-select';
import Icon from '../icon';
const DropdownIndicator = (props) => {
    const { selectProps: { inputValue, clearSearchValue }, } = props;
    const isSearching = typeof inputValue !== 'string' || inputValue !== '';
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(components.DropdownIndicator, { ...props }, isSearching ? (React.createElement("button", { type: "button", onClick: clearSearchValue },
        React.createElement(Icon, { name: "circle-xmark", className: "b-select__icon b-select__icon--search" }))) : (React.createElement(Icon, { name: "magnifying-glass", className: "b-select__icon b-select__icon--search" }))));
};
DropdownIndicator.propTypes = {
    selectProps: shape({
        inputValue: string,
        clearSearchValue: func.isRequired,
    }),
};
DropdownIndicator.defaultProps = {
    selectProps: {
        inputValue: '',
    },
};
export default DropdownIndicator;
